<template>
    <g fill="none" fill-rule="evenodd" opacity=".6">
        <path fill="#8E44AD" d="M0 9c0-4.97 4.037-9 9.002-9h21.996A9 9 0 0 1 40 9c0 4.97-4.037 9-9.002 9H9.002A9 9 0 0 1 0 9z"/>
        <path fill="#FFF" fill-rule="nonzero" d="M29.58 8.583c.752-.34 1.165-1.096 1.165-2.136C30.745 4.424 29.192 4 27.89 4h-2.903c-.475 0-.986.212-.986.676v8.661c0 .33.339.663.986.663h3.144c1.31 0 2.87-.512 2.87-2.95v-.286c0-1.43-.676-1.901-1.42-2.181zm-3.338-2.686h1.463c.539 0 .784.483.784.931 0 .456-.27.917-.784.917h-1.463V5.897zm2.502 4.976c0 .816-.374 1.23-1.11 1.23h-1.392V9.425h1.392c.757 0 1.11.39 1.11 1.23v.218z"/>
        <circle cx="9" cy="9" r="8" fill="#FFF"/>
    </g>
</template>

<script>
export default {
    name: 'switcherBDisabledIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 40 18');
    }
};
</script>
